<template>
  <div class="airportDetail">
    <div class="map">
      <GmapMap
        :center="{
          lat: info.lat,
          lng: info.lon
        }"
        :zoom="11"
        ref="map"
        style="width: 100%; height: 100%">
        <GmapMarker
          :position="{
            lat: info.lat,
            lng: info.lon
          }" />
      </GmapMap>
    </div>
    <div class="info">
      <p class="localtime colorGrey">{{localtime(info.localtime)}}</p>
      <!-- <div class="weatherBox">
      </div>
      cloud_friendly: {{info.cloud_friendly}}
      cloud_type: {{info.cloud_type}} -->
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
export default {
  name: 'AirportDetail',
  props: [
    'locale',
    'lang',
    'info'
  ],
  methods: {
    localtime (timezone) {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      const dateTime = `${date} ${time}`
      // const at = DateTime.fromISO(dateTime)

      return DateTime.fromISO(timezone).toFormat(dateTime)
    }
  }
}
</script>

<style lang="scss" scoped>
.airportDetail {
  border-top: 1px solid $color-lgrey2;
  background-color: $bg-default;
}
.map {
  height: 280px;
}
.info {
  padding: 5px 15px;
}
.localtime {
  margin-bottom: 10px;
  text-align: right;
  font-size: 0.8em;
}
</style>
